import { Card } from './card'
import { CardTotal } from './card-total'

export function SectionCards() {
  const currentDate = new Date()

  const threeMonthsAgo = new Date(currentDate)
  threeMonthsAgo.setMonth(currentDate.getMonth() - 3)

  const twoMonthsAgo = new Date(currentDate)
  twoMonthsAgo.setMonth(currentDate.getMonth() - 2)

  const oneMonthAgo = new Date(currentDate)
  oneMonthAgo.setMonth(currentDate.getMonth() - 1)

  return (
    <ul className="gap-4 grid grid-cols-2 md:grid-cols-4 overflow-auto">
      <li>
        <Card date={threeMonthsAgo} />
      </li>
      <li>
        <Card date={twoMonthsAgo} />
      </li>
      <li>
        <Card date={oneMonthAgo} />
      </li>
      <li>
        <CardTotal />
      </li>
    </ul>
  )
}
